<template>
  <MyForm :title="'Customer Details'">
     
    <template v-slot:fields>
      <div class="debug">
      <p>debugging Customer-details.vue:</p>
      <p>props.id = {{ id }}</p>
    </div>
      <Form-input
        v-model="customer.id"
        :readonly="true"
        :disabled="true"
        :name="'customer id:'"
      ></Form-input>
      <Form-input
        v-model="customer.created_by"
        :readonly="true"
        :disabled="true"
        :name="'created by:'"
      ></Form-input>
      <Form-input
        v-model="customer.created_on"
        :readonly="true"
        :disabled="true"
        :name="'created on:'"
      ></Form-input>
      <Form-input
        v-model="customer.modified_on"
        :readonly="true"
        :disabled="true"
        :name="'modified on:'"
      ></Form-input>

      <Form-input 
        v-model="customer.name" 
        :name="'name:'" 
        :readonly="currentGroup === 'admin' ? false : true"
        :disabled="currentGroup === 'admin' ? false : true">
      </Form-input>

      <Form-input 
        v-model="customer.companyName" 
        :name="'company name:'"
        :readonly="currentGroup === 'admin' ? false : true"
        :disabled="currentGroup === 'admin' ? false : true">
      </Form-input>

      <Form-input 
        v-model="customer.invoiceName" 
        :name="'invoice name:'"
        :readonly="currentGroup === 'admin' ? false : true"
        :disabled="currentGroup === 'admin' ? false : true">
      </Form-input>

      <Form-email 
        v-model="customer.email" 
        :name="'email:'"
        :readonly="currentGroup === 'admin' ? false : true"
        :disabled="currentGroup === 'admin' ? false : true">
      </Form-email>

      <FormTextArea 
        v-model="customer.notes" 
        :name="'notes:'"
        :readonly="currentGroup === 'admin' ? false : true"
        :disabled="currentGroup === 'admin' ? false : true">
      </FormTextArea>
      <Form-input
        v-model="customer.source"
        :name="'source:'"
        :placeholder="'word of mouth, website, kijiji, etc.'"
        :readonly="currentGroup === 'admin' ? false : true"
        :disabled="currentGroup === 'admin' ? false : true">
      </Form-input>
      <CheckboxGroup 
        :options="checkboxOptions" 
        v-model:checked="customer.archived"
        :readonly="currentGroup === 'admin' ? false : true"
        :disabled="currentGroup === 'admin' ? false : true">
      </CheckboxGroup>
    </template>

    <template v-slot:buttons>
      <div v-if="currentGroup === 'admin'" class="btn-footer" >
        <FormBtn :name="'Save Changes'" @clicked="submitForm"></FormBtn>
        <FormBtn :name="'Revert Changes'" @clicked="revertForm"></FormBtn>
        <FormBtn
          v-if="customerProjects.length < 1 && customerInvoices.length < 1 && customerPostechs.length <1"
          :name="'Delete Customer'"
          @clicked="deleteCustomer"
          :class="'red'"
        ></FormBtn>
      </div>
    </template>
  </MyForm>

  <!--div class="debug">
        <p> customer = {{ customer }}</p>
        <p> customer archived? {{ customer?.archived }}</p>
        <p> customer project count : {{ customerProjects.length }}</p>
        
    </div-->
  <div>
    <h3>Projects by Customer:</h3>
    <MyTable
      v-if="customerProjects.length > 0"
      :header="header"
      :data="customerProjects"
      :columns="header"
      @rowClicked="printRow"
    ></MyTable>
    <p v-else>No projects assigned.</p>
  </div>
  <br />
  <div v-if="currentGroup === 'admin' || currentGroup === 'standard'">
    <h3>Invoices by Customer:</h3>
    <MyTable
      v-if="customerInvoices.length > 0"
      :header="invHeader"
      :data="customerInvoices"
      :columns="invHeader"
      @rowClicked="goToInvoice"
    ></MyTable>
    <p v-else>No invoices assigned.</p>
  </div>
   <div v-if="currentGroup === 'admin' || currentGroup === 'standard'">
    <h3>Postechs by Customer:</h3>
    <MyTable
      v-if="customerPostechs.length > 0"
      :header="postechHeader"
      :data="customerPostechs"
      :columns="postechHeader"
      @rowClicked="goToPostech"
    ></MyTable>
    <p v-else>No Postechs assigned.</p>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import type { Customer } from '@/types/types'
import {
  useCustomerStore,
  useAlertStore,
  useProjectStore,
  useInvoiceStore,
  useUserStore,
  usePostechStore
} from '@/stores'
import MyTable from '@/components/MyTable.vue'
import router from '@/router'
import { storeToRefs } from 'pinia'
//import FormInput from '@/components/form/Form-input.vue';
import { MyForm, FormBtn, FormInput, FormEmail, FormTextArea, CheckboxGroup } from '@/components'

const userStore = useUserStore()
const { currentGroup } = storeToRefs(userStore)
const checkboxOptions = ref(['archived?'])
const customers = useCustomerStore()
const props = defineProps({ id: { type: Number, required: true } })
const customer = ref<Customer>()
await fetchCustomer()
//display table of projects by this customer:
const projectsStore = useProjectStore()
const { allProjects } = storeToRefs(projectsStore);
//const allProjects = await projectsStore.getAll()
const customerProjects = await allProjects.value.filter((proj) => {
  return proj.customer_id == customer.value.id
})
const invoiceStore = useInvoiceStore()
const { allInvoices } = storeToRefs(invoiceStore);
//const allInvoices = await invoiceStore.getAll()
const customerInvoices = await allInvoices.value.filter((inv) => {
  return inv.customer_id == customer.value.id
})
const postechStore = usePostechStore();
const { allPostech } = storeToRefs(postechStore);
//const allPostechs = await postechStore.getAll();
const customerPostechs = await allPostech.value.filter((postech=>{
  return postech.installer_id === customer.value.id;
}))
const header = ['id', 'projectName']
const invHeader = ['id', 'valueTotal']
const postechHeader = ['id', 'projectId']

function printRow(item: Project) {
  console.log('printRow..')
  console.log(JSON.stringify(item))
  //console.log("...pushing router to project_details");
  router.push(`/projects/${item.id.toString()}/details`)
}

function goToInvoice(item: Invoice) {
  console.log('goToInvoice()...')
  router.push(`/projects/${item.projectId.toString()}/invoices/${item.id}`)
}
function goToPostech(item: Postech) {
  console.log('goToPostech()...')
  router.push(`/projects/${item.projectId.toString()}/postech/${item.id}`)
}


watch(
  () => customer.value.name,
  (newVal, oldVal) => {
    customer.value.invoiceName =
      newVal + (customer.value.companyName != '' ? ' - ' + customer.value.companyName : '')
  },
  { deep: true }
)

watch(
  () => customer.value.companyName,
  (newVal, oldVal) => {
    customer.value.invoiceName =
      (customer.value.name != '' ? customer.value.name + ' - ' : '') + newVal
  },
  { deep: true }
)

async function fetchCustomer() {
  customer.value = await customers.fetchById(props.id)
}
//update customer
async function submitForm() {
  console.log('CustomerDetailsView.submitForm()...')
  customers.updateCustomer(customer.value)
}

async function revertForm() {
  console.log('CustomerDetailsView.revertForm()...')
  await fetchCustomer() //this doesnt exist
  //customer.value = await customers.getById(customerId);
}

async function deleteCustomer() {
  console.log('customer form delete...')
  const alert = useAlertStore()

  const msg = await customers.removeCustomer(customer.value.id) //TODO need to return the ID
  console.log('delete customer from backend, returns : ' + JSON.stringify(msg))
  //const objId = msg.id
  alert.success('removed customer ' + msg)
  //delay push for alert
 /* setTimeout(() => {
    alert.clear()
    //push to project details
    router.back() //go back in history
    //router.push(`/customers/`); //${objId}`)
 
  }, 2000)*/
}
</script>

<style lang="css" scoped>
/*.btn-footer {
  display: flex;
  flex-direction: row-reverse;
  gap: 1rem;
}*/

.emails-div {
  display: flex;
  flex-direction: row;
  gap: 5rem;
}
</style>
